import React from 'react';
import { RouteObject } from 'react-router-dom';

import RHIVersionGate from '@/components/RetailHealthInsurance/RHIVersionGate';

import DisableTextSelectionWrapper from '@/components/Common/Wrapper/DisableTextSelectionWrapper';
import BaseHealthInsurance from '@/pages/health-insurance/BaseHealthInsurance';
import RhiHome from '@/pages/health-insurance/home/RhiHome';

const PlansBenefits = React.lazy(
  () => import('@/pages/health-insurance/plans-benefits/index'),
);
const ChoosePlan = React.lazy(() => import('@/pages/health-insurance/plans'));
const AgentStart = React.lazy(() => import('@/pages/health-insurance/agent'));
const AgentNewQuote = React.lazy(
  () => import('@/pages/health-insurance/agent/new-quote'),
);
const PlanSelection = React.lazy(
  () => import('@/pages/health-insurance/plan-selection'),
);
const RetailHealthKyc = React.lazy(() => import('@/pages/health-insurance/kyc'));
const Proposal = React.lazy(() => import('@/pages/health-insurance/proposal'));
const ProposalReview = React.lazy(
  () => import('@/pages/health-insurance/proposal/review'),
);
const RetailHealthPayment = React.lazy(
  () => import('@/pages/health-insurance/payment'),
);
const RetailHealthPolicy = React.lazy(
  () => import('@/pages/health-insurance/policy'),
);
const RetailHealthRecommendation = React.lazy(
  () => import('@/pages/health-insurance/recommendation/index'),
);
const RetailHealthSelectMember = React.lazy(
  () => import('@/pages/health-insurance/select-member'),
);
const ThankYou = React.lazy(
  () => import('@/pages/health-insurance/thank-you/index'),
);
const RHIError = React.lazy(
  () => import('@/pages/health-insurance/error/index'),
);
const AddRiders = React.lazy(
  () => import('@/pages/health-insurance/add-riders/[insurer]'),
);
const MemberDetails = React.lazy(
  () => import('@/pages/health-insurance/member-details/index'),
);
const MemberDetailsForm = React.lazy(
  () => import('@/pages/health-insurance/member-details/[relation]'),
);

const VerifyDetails = React.lazy(
  () => import('@/pages/health-insurance/verify-details/index'),
);

const AddNominee = React.lazy(
  () => import('@/pages/health-insurance/add-nominee/index'),
);

const BankDetails = React.lazy(
  () => import('@/pages/health-insurance/bank-details/index'),
);

const Checkout = React.lazy(
  () => import('@/pages/health-insurance/checkout/index'),
);

const RetailHealthPolicyStatus = React.lazy(
  () => import('@/pages/health-insurance/policy-status/[status].tsx'),
);

export const healthInsuranceRoutes: RouteObject[] = [
  {
    path: 'health-insurance',
    element: (
      <DisableTextSelectionWrapper>
        <BaseHealthInsurance />
      </DisableTextSelectionWrapper>
    ),
    children: [
      {
        path: '',
        element: <RhiHome />,
      },
      {
        path: 'recommendation',
        element: <RetailHealthRecommendation />,
      },
      {
        path: 'select-member',
        element: <RetailHealthSelectMember />,
      },
      {
        path: 'plans-benefits',
        element: <PlansBenefits />,
      },
      {
        path: 'agent',
        element: <AgentStart />,
      },
      {
        path: 'agent/new-quote',
        element: <AgentNewQuote />,
      },
      {
        path: 'plans',
        element: <ChoosePlan />,
      },
      {
        path: 'plans/:planId',
        element: <PlanSelection />,
      },
      {
        path: 'kyc/:planId',
        element: <RetailHealthKyc />,
      },
      {
        path: 'proposal/:planId',
        element: <Proposal />,
      },
      {
        path: 'proposal/:planId/review',
        element: <ProposalReview />,
      },
      {
        path: 'payment/:planId',
        element: <RetailHealthPayment />,
      },
      {
        path: 'policy/:planId',
        element: <RetailHealthPolicy />,
      },
      {
        path: 'thank-you',
        element: <ThankYou />,
      },
      {
        path: 'error',
        element: <RHIError />,
      },
      {
        element: <RHIVersionGate />,
        children: [
          { path: 'add-riders/:planId', element: <AddRiders /> },
          { path: 'verify-details', element: <VerifyDetails /> },
          { path: 'add-nominee', element: <AddNominee /> },
          { path: 'member-details', element: <MemberDetails /> },
          { path: 'member-details/:relation', element: <MemberDetailsForm /> },
          { path: 'checkout', element: <Checkout /> },
          { path: 'bank-details', element: <BankDetails /> },
        ],
      },
      { path: 'policy-status', element: <RetailHealthPolicyStatus /> },
      { path: 'policy-status/:status', element: <RetailHealthPolicyStatus /> },
    ],
  },
];
